var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00033 13.5833C0.987803 13.5833 0.166992 14.4041 0.166992 15.4167C0.166992 16.4292 0.987803 17.25 2.00033 17.25C3.01285 17.25 3.83366 16.4292 3.83366 15.4167C3.83366 14.4041 3.01285 13.5833 2.00033 13.5833Z",
    fill: "#696974"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00033 7.16667C0.987803 7.16667 0.166992 7.98748 0.166992 9C0.166992 10.0125 0.987803 10.8333 2.00033 10.8333C3.01285 10.8333 3.83366 10.0125 3.83366 9C3.83366 7.98748 3.01285 7.16667 2.00033 7.16667Z",
    fill: "#696974"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00033 0.75C0.987803 0.75 0.166992 1.57081 0.166992 2.58333C0.166992 3.59585 0.987803 4.41667 2.00033 4.41667C3.01285 4.41667 3.83366 3.59585 3.83366 2.58333C3.83366 1.57081 3.01285 0.75 2.00033 0.75Z",
    fill: "#696974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.b8954bc243ac3ffacdbdccb9cad7d923.svg";
export { ForwardRef as ReactComponent };